import React from 'react'
import { Button, Col, Row } from 'reactstrap'
interface TemplateType {
    setState: (state: boolean) => void;
}
const Template = ({ setState }: TemplateType) => {

    return (
        <React.Fragment>
            <div className='p-2'>
                <h6>Steps :</h6>
                <ol>
                    <li>Download template file of user.</li>
                    <li>Fill  all valid data in the given fields.</li>
                    <li>Do not modify any column heading or add extra columns.</li>
                </ol>
                <div className='mt-0'>
                    <Button
                        className="btn_size_cstm btn-sm mr-1 max-width-10"
                        color="primary"
                    >
                        <i className="mdi mdi-download font-size-16 align-middle me-1" />Download
                    </Button>
                </div>
                <Row className='d-flex ms-auto justify_right p-2'>
                    <Col>
                        <Button color='danger' onClick={() => { setState(false) }}>Cancel</Button>
                    </Col>
                    <Col>
                        <Button color='primary'
                            onClick={() => {
                                setState(false)
                            }}>Ok</Button>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default Template